export default __webpack_public_path__ + "static/media/gino.6c3a5a12.png";